import { IFormService } from "../../service/form/FormService";

export default class GetReportingPeriodFormTypesInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(reportingPeriodApplicantId: number) {
    return this.formService.getReportingPeriodFormTypes(
      reportingPeriodApplicantId
    );
  }
}
